export default "__VITE_ASSET__Cqn_4rtc__"